import React from 'react';
import PropTypes from 'prop-types';
import { compose, lifecycle, pure, withState, withHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Form as FinalForm } from 'react-final-form';
import createFocusDecorator from 'final-form-focus';
import * as R from 'ramda';

import * as actions from 'actions';

import { holdMutators } from 'utils';

import Form from './Form';
import { decorator, handlers } from './shared';

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.shape({
    appraisalPayment: PropTypes.objectOf(PropTypes.any),
    token: PropTypes.string,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  setSuccessTrue: PropTypes.func.isRequired,
};

const focusOnError = createFocusDecorator();

function New({ match, initialValues, setSuccessTrue }) {
  const isAllPropertiesMultiFamily = R.path(['appraisalPayment', 'isAllPropertiesMultiFamily'], initialValues);
  return (
    <FinalForm
      onSubmit={() => { }}
      decorators={[focusOnError, decorator]}
      initialValues={initialValues}
      isAllPropertiesMultiFamily={isAllPropertiesMultiFamily}
      mutators={{ ...holdMutators }}
      subscription={{ submitError: true, submitting: true, pristine: true }}
      component={Form}
      token={match.params.token}
      setSuccessTrue={setSuccessTrue}
    />
  );
}

New.propTypes = propTypes;

function mapDispatchToProps(dispatch) {
  return {
    fetchAppraisalPayment: bindActionCreators(actions.fetchAppraisalPayment, dispatch),
    createAppraisalPayment: bindActionCreators(actions.createAppraisalPayment, dispatch),
  };
}

const enhance = compose(
  withRouter,
  connect(
    null,
    mapDispatchToProps,
  ),
  withHandlers({
    setDefaultInitialValues: handlers.setDefaultInitialValues,
  }),
  withState('initialValues', 'setInitialValues', ({ setDefaultInitialValues }) => setDefaultInitialValues()),
  withHandlers({
    mergeInitialValues: handlers.mergeInitialValues,
  }),
  lifecycle({
    async componentDidMount() {
      const { match, fetchAppraisalPayment, mergeInitialValues } = this.props;
      const { token } = match.params;
      await fetchAppraisalPayment(token).then(mergeInitialValues);
    },
  }),
  pure,
);

export default enhance(New);
